/* eslint-disable @typescript-eslint/naming-convention */
export class FormPatterns {
    /**
     * String type check
     */
    public static USERNAME_REGEXP: RegExp = /^.*$/;
    public static PWD_REGEXP: RegExp = /([^<>"’&]{8,20}$)/;
    public static NAME_REGEXP: RegExp = /^[a-zA-Z-'` ÀÂÄÇÈÉÊËÎÏÔÖÙÛÜàáâäçèéêëîïôöùûü]+$/;
    public static PWDLOGIN_REGEXP: RegExp = /([^<>"’&]{4,20}$)/;
    // eslint-disable-next-line max-len
    public static EMAIL_REGEXP: RegExp =
        /^([a-z0-9,!\#\$%&'\*\+\/=\?\^_`\{\|\}~-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z0-9,!\#\$%&'\*\+\/=\?\^_`\{\|\}~-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*@([a-z0-9-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z0-9-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*\.(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]){2,})$/i;
    // public static STRINGS_ONLY: RegExp = /\D/;
    /**
     * Number type check
     */
    public static NUM: RegExp = /(\d)/;
    public static NUMBER: RegExp = /^\d+$/;
    public static PHONE_REGEXP: RegExp = /^0[1-9]\d{8}$/;
    public static PHONE_HOME_REGEXP: RegExp = /^0[1-5]\d{8}$/;
    public static PHONE_HOME_ONLY_REGEXP: RegExp = /^0[1-59]\d{8}$/;
    public static PHONE_MOBILE_REGEXP: RegExp = /^0[6-7]\d{8}$/;
    public static PHONE_HOME_EXTENSION_REGEXP: RegExp = /^0[1-5]$/;
    public static FRENCH_SIMPLE_DATE_REGEXP: RegExp = /(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[012])\/(19|20)\d\d$'/;
    public static ZIP_REGEXP: RegExp = /^\d{5}$/;
    public static SIREN_REGEXP: RegExp = /^\d{9}$/;
    public static DAD_CONTRACT_ID: RegExp = /^\d{13}$/;
    public static IMEI: RegExp = /^\d{15}$/;

    /**
     * Alphanum type check
     */
    public static ALPHANUM: RegExp = /([a-zA-Z0-9])/;
    public static IBAN: RegExp = /^FR\d{12}[0-9A-Z]{11}\d{2}$/;

    public static POSTAL_CODE: RegExp = /^\d{5}$/;
    public static STREET_NUMBER: RegExp = /^\d+[A-Za-z]?$/;
    public static CLEAN_STREETS: RegExp = /LIEU DIT |AU |AUX |DE |DES |DU |D |LE |LA |L |LES /;
}
